import { apiFetch } from '../utils/api';

export interface VehicleBrand {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  relatedVariantCount?: number;
}

export interface VehicleBrandMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface PaginatedVehicleBrandsResponse {
  data: VehicleBrand[];
  meta: VehicleBrandMeta;
}

interface FetchVehicleBrandsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const fetchVehicleBrands = (
  params: FetchVehicleBrandsParams = {},
): Promise<PaginatedVehicleBrandsResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.search) {
    searchParams.set('search', params.search.trim());
  }

  const query = searchParams.toString();
  return apiFetch<PaginatedVehicleBrandsResponse>(
    `/vehicle/brands${query ? `?${query}` : ''}`,
  );
};

export const createVehicleBrand = (payload: { name: string }) =>
  apiFetch<VehicleBrand>('/vehicle/brands', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const updateVehicleBrand = (
  id: string,
  payload: { name: string },
) =>
  apiFetch<VehicleBrand>(`/vehicle/brands/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });

export const deleteVehicleBrand = (id: string) =>
  apiFetch<void>(`/vehicle/brands/${id}`, {
    method: 'DELETE',
  });

export const fetchVehicleBrand = (id: string) =>
  apiFetch<VehicleBrand>(`/vehicle/brands/${id}`);
